// removed by extract-text-webpack-plugin
module.exports = {"footerRow":"src-components-Footer----index-module---footerRow---3v4ii","cell":"src-components-Footer----index-module---cell---AJK7w"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/index.module.scss
// module id = 315
// module chunks = 114276838955818